import React from 'react';
import { AdminProvider } from '../admin/AdminContext';
import AnalyticsView from '../admin/pages/AnalyticsView';

export default function AdminStats() {
  return (
    <AdminProvider>
      <AnalyticsView />
    </AdminProvider>
  );
}
